import { NgModule, ModuleWithProviders }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgUploaderModule } from 'ngx-uploader';
import { AppTranslationModule } from '../app.translation.module';

import { DateTimePickerModule } from 'ng-pick-datetime';

import { ModalSurvey } from './components/modals/components/modalSurvey/modalSurvey.component';
import { ModalSurveyPlan } from './components/modals/components/modalSurveyPlan/modalSurveyPlan.component';
import { ModalCompleteDay } from './components/modals/components/modalCompleteDay/modalCompleteDay.component';
import { ModalGeneralConfig } from './components/modals/components/modalGeneralConfig/modalGeneralConfig.component';
import { ModalDelete } from './components/modals/components/modalDelete/modalDelete.component';
import { ModalLogout } from './components/modals/components/modalLogout/modalLogout.component';
import { ModalUser } from './components/modals/components/modalUser/modalUser.component';
import { ModalEditUser } from './components/modals/components/modalEditUser/modalEditUser.component';
import { ModalImport } from './components/modals/components/modalImport/modalImport.component';
import { ModalImportRH } from './components/modals/components/modalImportRH/modalImportRH.component';
import { ModalConfirm } from './components/modals/components/modalConfirm/modalConfirm.component';
import { ModalMessage } from './components/modals/components/modalMessage/modalMessage.component';
import { ModalMessageOk } from './components/modals/components/modalMessageOk/modalMessageOk.component';
import { ModalConfirmarCierre } from './components/modals/components/modalConfirmarCierre/modalConfirmarCierre.component';
import { ModalHistorialRH } from './components/modals/components/modalHistorialRH/modalHistorialRH.component';

import { NguiAutoCompleteModule } from '@ngui/auto-complete';

import {
  BaThemeConfig
} from './theme.config';

import {
  BaThemeConfigProvider
} from './theme.configProvider';

import {
  BaAmChart,
  BaBackTop,
  BaCard,
  BaChartistChart,
  BaCheckbox,
  BaContentTop,
  BaFullCalendar,
  BaMenuItem,
  BaMenu,
  BaMultiCheckbox,
  BaPageTop,
  BaPictureUploader,
  BaSidebar,
  BaFileUploader
} from './components';

import { BaCardBlur } from './components/baCard/baCardBlur.directive';

import {
  BaScrollPosition,
  BaSlimScroll,
  BaThemeRun
} from './directives';

import {
  BaAppPicturePipe,
  BaKameleonPicturePipe,
  BaProfilePicturePipe,
  DataFilterPipe
} from './pipes';

import {
  BaImageLoaderService,
  BaMenuService,
  BaThemePreloader,
  BaThemeSpinner
} from './services';

import {
  EmailValidator,
  EqualPasswordsValidator
} from './validators';

const NGA_COMPONENTS = [
  BaAmChart,
  BaBackTop,
  BaCard,
  BaChartistChart,
  BaCheckbox,
  BaContentTop,
  BaFullCalendar,
  BaMenuItem,
  BaMenu,
  BaMultiCheckbox,
  BaPageTop,
  BaPictureUploader,
  BaSidebar,
  BaFileUploader
];

const NGA_DIRECTIVES = [
  BaScrollPosition,
  BaSlimScroll,
  BaThemeRun,
  BaCardBlur
];

const NGA_PIPES = [
  BaAppPicturePipe,
  BaKameleonPicturePipe,
  BaProfilePicturePipe,
  DataFilterPipe
];

const NGA_SERVICES = [
  BaImageLoaderService,
  BaThemePreloader,
  BaThemeSpinner,
  BaMenuService
];

const NGA_VALIDATORS = [
  EmailValidator,
  EqualPasswordsValidator
];

@NgModule({
  declarations: [
    ...NGA_PIPES,
    ...NGA_DIRECTIVES,
    ...NGA_COMPONENTS,
    ModalSurvey,
    ModalSurveyPlan,
    ModalCompleteDay,
    ModalGeneralConfig,
    ModalDelete,
    ModalLogout,
    ModalUser,
    ModalEditUser,
    ModalImport,
    ModalImportRH,
    ModalConfirm,
    ModalMessage,
    ModalMessageOk,
    ModalConfirmarCierre,
    ModalHistorialRH
  ],
  entryComponents: [
    ModalSurvey,
    ModalSurveyPlan,
    ModalCompleteDay,
    ModalGeneralConfig,
    ModalDelete,
    ModalLogout,
    ModalUser,
    ModalEditUser,
    ModalImport,
    ModalImportRH,
    ModalConfirm,
    ModalMessage,
    ModalMessageOk,
    ModalConfirmarCierre,
    ModalHistorialRH
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AppTranslationModule,
    NgUploaderModule,
    DateTimePickerModule,
    NguiAutoCompleteModule
  ],
  exports: [
    ...NGA_PIPES,
    ...NGA_DIRECTIVES,
    ...NGA_COMPONENTS
  ]
})
export class NgaModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders> {
      ngModule: NgaModule,
      providers: [
        BaThemeConfigProvider,
        BaThemeConfig,
        ...NGA_VALIDATORS,
        ...NGA_SERVICES
      ],
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/nga.module.ts